import DownloadIcon from 'components/icons/Download';
import Link from 'components/links/Link';

export default function TeamPerson({staff}) {
  const disclaimer = staff.conflict ? <p>{staff.conflict}</p> : null;
  const dlIcon = staff.biosketchUrl && staff.biosketchUrl.endsWith('.pdf') ? <DownloadIcon /> : null;
  const bsLink = staff.biosketchUrl && <span><Link newTab={true} href={staff.biosketchUrl}>{dlIcon}NIH Biosketch</Link></span>;

  return (
    <div key={staff.name} className="staff-item">
      <img className="avatar" src={staff.image} alt={staff.name} />
      <div className="staff-meta">
        <h4 className="staff-name">{staff.name}</h4>
        <span className="staff-title">{staff.title}</span>
        <div className="staff-details">
          <p>{staff.bio}</p>
          {disclaimer}
          {bsLink}
        </div>
      </div>
    </div>
  );
}
